<template>
  <div class="main">
    <div class="wrapPortable Indica">
      <h1 class="indH1">Bonjour {{user.nom}} {{user.prenom}}</h1>
    </div>
      <ul class="accueil">
          <li class="li-accueil">
              <router-link to="/session_co" title="Accueil individuel" class="a-accueil">
                Débuter une session Collective <p><img src="../assets/logo/logo-collective.png" class="puce-accueil debut" alt="logo althère"></p>
              </router-link>
          </li>
          <li class="li-accueil">
              <router-link to="/accueil" title="Accueil individuel" class="a-accueil">
                Débuter une session Individuelle <p><img src="../assets/logo/logo-homme.png" class="puce-accueil" alt="logo loupe"></p>
              </router-link>
          </li>
          <li class="li-accueil fin">
              <a href="#" class="a-accueil">Consulter mes cours <p><img src="../assets/logo/picto-cercle_Exercices_blanc.png" class="puce-accueil" alt="logo photo"></p></a>
          </li>
      </ul>
  </div>
</template>

<script>
import { User } from "../controller/user.js"

export default {
  name: "Accueil_Coach",
  data() {
    return {
       user: JSON.parse(localStorage.user)|| [],
    };
  },
  created(){
    if (typeof(localStorage.user) !== undefined && localStorage.length > 1 ){
      try {
        JSON.parse(localStorage.user);
        this.user = JSON.parse(localStorage.user);
      } catch (error) {
        this.$router.push({ name: 'connexion' });
      } 
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AccueilCoach.vue